import React from "react";
import { Link } from "react-router-dom";

const PromotionalTwo = () => {
  return (
    <section className="sx-about-section">
      <div className="sx-about-container">
        {/* LEFT CONTENT */}
        <div className="sx-about-content">
          <span className="sx-about-label">About Awaneez</span>

          <h2 className="sx-about-title">
            Simplifying Printing <br />
            <span>For Homes & Businesses</span>
          </h2>

          <p className="sx-about-text">
            Awaneez is built around one simple idea — making printing reliable,
            affordable, and stress-free. We help customers choose the right
            printers and supplies without confusion or compromise.
          </p>

          <p className="sx-about-text">
            Whether you’re setting up a home workspace, managing office
            operations, or upgrading existing equipment, Awaneez delivers
            trusted products backed by genuine supplies and dependable service.
          </p>

          <ul className="sx-about-points">
            <li>✔ Carefully selected home & office printers</li>
            <li>✔ Genuine ink, toner, and paper solutions</li>
            <li>✔ Fast delivery with expert guidance</li>
          </ul>

          <div className="sx-about-actions">
            <Link to="/about-us" className="sx-btn-primary">
              Discover Our Story
            </Link>
            <Link to="/contact-us" className="sx-btn-secondary">
              Talk to an Expert
            </Link>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="sx-about-visual">
          <img src="/assets/images/bg/banner-thumb.png" alt="About Awaneez" />
          <div className="sx-about-badge">
            Trusted by thousands of customers nationwide
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= SECTION ================= */
        .sx-about-section {
          padding: 90px 0;
          background: white;
        }

        .sx-about-container {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 50px;
        }

        /* ================= CONTENT ================= */
        .sx-about-content {
          max-width: 55%;
        }

        .sx-about-label {
          display: inline-block;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1px;
          color: #0b5ed7;
          margin-bottom: 16px;
          text-transform: uppercase;
        }

        .sx-about-title {
          font-size: 40px;
          font-weight: 800;
          line-height: 1.25;
          color: #111;
          margin-bottom: 18px;
        }

        .sx-about-title span {
          color: #0b5ed7;
        }

        .sx-about-text {
          font-size: 17px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 16px;
          max-width: 620px;
        }

        .sx-about-points {
          list-style: none;
          padding: 0;
          margin: 20px 0 30px;
        }

        .sx-about-points li {
          font-size: 15px;
          color: #222;
          margin-bottom: 10px;
          font-weight: 600;
        }

        /* ================= BUTTONS ================= */
        .sx-about-actions {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .sx-btn-primary {
          background: #0b5ed7;
          color: #fff;
          padding: 14px 30px;
          font-size: 15px;
          font-weight: 700;
          text-decoration: none;
          transition: background .25s ease;
        }

        .sx-btn-primary:hover {
          background: #084bb0;
        }

        .sx-btn-secondary {
          border: 2px solid #0b5ed7;
          color: #0b5ed7;
          padding: 14px 30px;
          font-size: 15px;
          font-weight: 700;
          text-decoration: none;
          transition: .25s ease;
        }

        .sx-btn-secondary:hover {
          background: #0b5ed7;
          color: #fff;
        }

        /* ================= IMAGE ================= */
        .sx-about-visual {
          position: relative;
          max-width: 45%;
        }

        .sx-about-visual img {
          width: 100%;
          display: block;
          box-shadow: 0 18px 40px rgba(0,0,0,0.15);
        }

        .sx-about-badge {
          position: absolute;
          bottom: 20px;
          left: 20px;
          background: rgba(11, 94, 215, 0.9);
          color: #fff;
          padding: 10px 18px;
          font-size: 13px;
          font-weight: 700;
        }

        /* ================= MOBILE ================= */
        @media(max-width: 900px) {
          .sx-about-container {
            flex-direction: column;
          }

          .sx-about-content,
          .sx-about-visual {
            max-width: 100%;
          }

          .sx-about-title {
            font-size: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default PromotionalTwo;
